module.exports = __webpack_public_path__ + "img/book.753616e6.svg";